// TO DO:
// Write the ar-api code
// createAPIs
import { defineNuxtPlugin } from 'nuxt/app'
import type { AxiosInstance } from 'axios'
import { createAPIs } from '@/api/'

export default defineNuxtPlugin({
  name: 'api',
  dependsOn: ['vuex', 'axios'],
  enforce: 'pre',
  setup: (nuxtApp) => {
    const factories = createAPIs(nuxtApp.$axios as AxiosInstance)
    nuxtApp.provide('api', factories)
  } })
